module.exports = __webpack_public_path__ + "static/media/firstScreen@3x.893e6741.png";